module.exports = __webpack_public_path__ + "static/img/bg_mod_finance.664a32ad.jpg";